import { Button, ButtonGroup } from '@mui/material';

type ToggleOptionItem = {
  label: string;
  value: string;
};

type ToggleOptionsButtonProps = {
  options: ToggleOptionItem[];
  currentOption: string;
  onSelect?: (args: { option: ToggleOptionItem }) => void;
  isDisabled?: boolean;
};

export const ToggleOptionsButton = ({
  options,
  currentOption,
  onSelect,
  isDisabled,
}: ToggleOptionsButtonProps) => {
  return (
    <ButtonGroup
      sx={{
        '& .MuiButton-root': {
          fontSize: { xs: '0.75rem', sm: '0.875rem' },
          px: { xs: 1.5, sm: 2 },
          py: { xs: 0.5, sm: 0.75 },
          minWidth: { xs: '60px', sm: '80px' },
        },
        '& .MuiButtonGroup-grouped:not(:last-of-type)': {
          borderRight: '1px solid',
          borderRightColor: 'inherit',
        },
      }}
    >
      {options.map((option) => (
        <Button
          key={option.value}
          color="primary"
          variant="outlined"
          onClick={() => onSelect?.({ option })}
          disabled={isDisabled}
          sx={{
            borderColor: option.value === currentOption ? 'primary.main' : 'divider',
            zIndex: option.value === currentOption ? 1 : 'auto',
            position: 'relative',
            ...(option.value === currentOption
              ? {
                  '&:not(:first-of-type)': {
                    borderLeft: '1px solid',
                    borderLeftColor: 'primary.main',
                  },
                  '&:not(:last-of-type)': {
                    borderRight: '1px solid',
                    borderRightColor: 'primary.main',
                  },
                  '& + .MuiButton-root': {
                    borderLeft: '1px solid',
                    borderLeftColor: 'primary.main',
                  },
                }
              : {}),
            backgroundColor:
              option.value === currentOption ? 'rgba(251, 140, 0, 0.08)' : 'transparent',
            fontWeight: option.value === currentOption ? 600 : 400,
            '&:hover': {
              backgroundColor:
                option.value === currentOption
                  ? 'rgba(251, 140, 0, 0.12)'
                  : 'rgba(255, 255, 255, 0.05)',
              borderColor: option.value === currentOption ? 'primary.main' : 'action.hover',
            },
          }}
        >
          {option.label}
        </Button>
      ))}
    </ButtonGroup>
  );
};
